import { Type } from '@sinclair/typebox';
import { cartCommandsSchema } from "../commands/index.mjs";
import { cartSchema } from "./cart.mjs";
const ErrorMessages = [
    'UNKNOWN_ERROR',
    'INVALID_SHIPPING_METHOD',
    'STICKER_PACK_NOT_FOUND',
    'CANNOT_BUY_GIFT_CARDS_WITH_A_GIFT_CARD',
    'LINE_ITEM_NOT_FOUND',
    'INVALID_EMAIL',
    'ORDER_NOT_FOUND',
    'CODE_ALREADY_ADDED',
    'INVALID_CODE',
    'GIFT_CARD_ALREADY_USED',
    'CODE_NOT_FOUND',
    'INVALID_VAT_NUMBER',
    'CATALOG_ITEM_NOT_FOUND',
    'CATALOG_ITEM_ALREADY_IN_ANOTHER_CART',
    'QUANTITY_MUST_BE_GREATER_THAN_0',
    'QUANTITY_MUST_BE_GREATER_THAN_MINIMUM',
    'SHOP_ITEM_NOT_FOUND',
    'CUSTOM_STICKER_NOT_FOUND',
    'INVALID_PAYMENT_METHOD',
    'CART_HAS_ALREADY_BEEN_PAID_FOR',
    'GIFT_CARDS_TEMPORARILY_DISABLED',
];
// TODO: these translations should not exist in the checkout-api
export const defaultErrorMessageTranslations = {
    UNKNOWN_ERROR: 'Unknown error',
    INVALID_SHIPPING_METHOD: 'Invalid shipping method',
    STICKER_PACK_NOT_FOUND: 'Sticker pack not found',
    CANNOT_BUY_GIFT_CARDS_WITH_A_GIFT_CARD: 'Cannot buy gift cards with a gift card',
    LINE_ITEM_NOT_FOUND: 'Line item not found',
    ORDER_NOT_FOUND: 'Order not found',
    INVALID_EMAIL: 'Invalid email',
    CODE_ALREADY_ADDED: 'Code already added',
    INVALID_CODE: 'Invalid code',
    GIFT_CARD_ALREADY_USED: 'Gift card already used',
    CODE_NOT_FOUND: 'Code not found',
    INVALID_VAT_NUMBER: 'Invalid vat number',
    CATALOG_ITEM_NOT_FOUND: 'Catalog item not found',
    CATALOG_ITEM_ALREADY_IN_ANOTHER_CART: 'Catalog item already in another cart',
    QUANTITY_MUST_BE_GREATER_THAN_0: 'Quantity must be greater than 0',
    QUANTITY_MUST_BE_GREATER_THAN_MINIMUM: 'Quantity must be greater than minimum',
    SHOP_ITEM_NOT_FOUND: 'Shop item not found',
    CUSTOM_STICKER_NOT_FOUND: 'Custom sticker not found',
    INVALID_PAYMENT_METHOD: 'Invalid payment method',
    CART_HAS_ALREADY_BEEN_PAID_FOR: 'Cart has already been paid for',
    GIFT_CARDS_TEMPORARILY_DISABLED: 'Giftcards are temporarily disabled',
};
export const cartCommandResponseSchema = Type.Object({
    commandId: Type.String(),
    success: Type.Boolean(),
    errorCode: Type.Optional(Type.Union(ErrorMessages.map((x) => Type.Literal(x)))),
    translatedErrorCode: Type.Optional(Type.String()),
    // TODO: this should probably be removed or made to match StoredCart
    cartUpdate: Type.Optional(Type.Partial(cartSchema)),
});
export const updateCartRequestSchema = Type.Object({
    commands: Type.Array(cartCommandsSchema, { minItems: 1 }),
});
export const cartUpdateResponseSchema = Type.Object({
    commands: Type.Array(cartCommandResponseSchema),
    cart: cartSchema,
});
export const cartResponseSchema = Type.Object({
    cart: cartSchema,
    sdkVersion: Type.Optional(Type.String()),
});
export const maybeCartResponseSchema = Type.Object({
    cart: Type.Optional(cartSchema),
});
export const myCartsResponseSchema = Type.Object({
    carts: Type.Array(Type.Object({ cartId: Type.String() })),
});
//# sourceMappingURL=requests.js.map